'use client'

import { useAuth } from '@clerk/nextjs'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect } from 'react'

/**
 * Component that checks if user has an organization and redirects to dashboard if not
 * Also provides context for disabling navigation
 */
export default function OrgGuard({ children }) {
  const { orgId } = useAuth()
  const pathname = usePathname()
  const router = useRouter()

  useEffect(() => {
    // If user has no organization and is not on dashboard, redirect to dashboard
    if (!orgId && pathname !== '/dashboard') {
      router.push('/dashboard')
    }
  }, [orgId, pathname, router])

  return children
}

/**
 * Hook to check if navigation should be disabled (no organization)
 */
export function useOrgStatus() {
  const { orgId } = useAuth()
  return {
    hasOrganization: !!orgId,
    isDisabled: !orgId
  }
}
